/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import MandateListItem from './MandateListItem'
import { getMandateLinkTemplate } from '../../lib/links/mandateLinks'

export type MandateListProps = {
  items: Mandate[]
  itemLink?: string
}

function MandateList (props: MandateListProps) {
  const {
    items,
    itemLink = getMandateLinkTemplate()
  } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={130}>
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th w={130}>
            <FormattedMessage
              id="number"
              defaultMessage="Numéro"
            />
          </Table.Th>
          <Table.Th w={220}>
            <FormattedMessage
              id="type"
              defaultMessage="Type"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="customer"
              defaultMessage="Client"
            />
          </Table.Th>
          <Table.Th w={120} ta="end">
            <FormattedMessage
              id="price"
              defaultMessage="Prix"
            />
            &nbsp;/&nbsp;
            <FormattedMessage
              id="rent"
              defaultMessage="Loyer"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="start_date"
              defaultMessage="Date de début"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="end_date"
              defaultMessage="Date de fin"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <MandateListItem
              key={item.id}
              item={item}
              itemLink={itemLink}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={9}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default MandateList
